// ** Third Party Components
import styled, { css } from "styled-components";

// ** Custom Components
import Block from "components/layout/Block";

// #####################################################

export const StyledBlockModerate = styled(({ moderate, ...props }) => (
	<Block {...props} />
))`
	${({ moderate }) =>
		moderate &&
		css`
			padding: 0.75rem;
			background-color: ${({ theme: { colors } }) =>
				colors.buttonsDefaultGrey};
			border-radius: ${({ theme: { borderRadius } }) =>
				borderRadius.element};

			& + & {
				margin-top: 1rem;
			}
		`}

	${({ noMarginTop }) =>
		noMarginTop &&
		css`
			margin-top: 0 !important;
		`}
`;

// #####################################################
